var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{staticClass:"weui-switch",class:{'weui-switch-on': _vm.checked, 'big': _vm.size === 'big'},attrs:{"value":_vm.value},on:{"click":function($event){$event.stopPropagation();return _vm.toggle.apply(null, arguments)}}})])}
var staticRenderFns = []

export { render, staticRenderFns }